/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { Icon } from 'ui';
import { routes as ROUTES } from 'constants/config';
import classNames from 'classnames';
import LastModifiedCell from 'components/shared/index/last_modified_cell';
import DateFormat from 'constants/date_format';
import IndexTableRow from '../../shared/index/table_row';
import IndexTableBodyCell from '../../shared/index/table/body_cell';
import RowTags from '../../shared/index/row_tags';

const STATES = {
  DRAFT: 'draft',
  NEW_VERSION_PENDING: 'new_version_pending',
  PUBLISHED: 'published',
};

const translations = {
  [STATES.DRAFT]: t('drafts.state.draft'),
  [STATES.NEW_VERSION_PENDING]: t('drafts.state.new_version_pending'),
  [STATES.PUBLISHED]: t('drafts.state.published'),
};

const TitleIcon = ({ type, isCertification }) => (
  <span>
    {(type === 'path' || type === 'practice/container') && !isCertification && (
      <Icon
        className="mr-4 c-brand-gray-dark"
        name={type === 'practice/container' ? 'star_outline' : type}
      />
    )}
    {type === 'path' && isCertification && (
      <Icon className="mr-4 c-brand-gray-dark" name="new-certification-badge" />
    )}
  </span>
);

const StateCell = ({ state }) => {
  const indicatorClassName = classNames('Pill Pill--dot mr-8', {
    'Pill--outline': state === STATES.NEW_VERSION_PENDING,
    'Pill--tealLighter': state === STATES.DRAFT,
  });

  return (
    <IndexTableBodyCell size="l" name="state" contentClassName="d-b">
      <span className={indicatorClassName} />
      <span className="fz-base h-c-gray-darker">{translations[state]}</span>
    </IndexTableBodyCell>
  );
};

const TitleCell = ({
  title,
  urls,
  type,
  published,
  lessons,
  description,
  tagsData,
  filterByTag,
  hasTags,
  id,
  scorm,
  isDraft,
  features,
  userCanUpdateContent,
  isCertification,
}) => {
  return (
    <IndexTableBodyCell size="xl" name="title" split>
      <div>
        {!published ? (
          <a href={ROUTES.JOURNEY.EDIT(id, true)}>
            <TitleIcon type={type} isCertification={isCertification} />
            {title}
          </a>
        ) : (
          <a href={ROUTES.JOURNEY.EDIT(id)}>
            <TitleIcon type={type} isCertification={isCertification} />
            {title}
          </a>
        )}
        <div className="Index-tableSecondaryField">
          {hasTags && (
            <RowTags
              data={tagsData}
              href={ROUTES.JOURNEY.EDIT(id)}
              onTagClick={filterByTag}
            />
          )}
        </div>
      </div>
      <div className="IndexAction-container">
        {!published && (
          <a
            className="IndexAction-button IndexAction-button--square"
            target={`lesson_edit_${id}`}
            href={ROUTES.JOURNEY.EDIT(id)}
            aria-label={t('common.edit')}
          >
            <Icon name="edit" />
          </a>
        )}
      </div>
    </IndexTableBodyCell>
  );
};

// const AverageScoreCell = () => (
//   <IndexTableBodyCell size="s" name="last-activity" hideBelowMD center>
//     -
//   </IndexTableBodyCell>
// );

// const TimesCompletedCell = () => (
//   <IndexTableBodyCell size="s" name="last-activity" hideBelowMD center>
//     -
//   </IndexTableBodyCell>
// );

// const LastCompletedCell = () => (
//   <IndexTableBodyCell size="s" name="last-activity" hideBelowMD center>
//     -
//   </IndexTableBodyCell>
// );

const JourneyRow = props => (
  <IndexTableRow index={props.index} checkBoxDisabled selectable={false}>
    <TitleCell {...props} selected={undefined} />
    <StateCell state={props.published ? 'published' : 'draft'} />
    <LastModifiedCell
      lastModified={{
        date:
          moment(props.updatedAt).format(DateFormat.fixed.ISO8601_LOCAL) + 'Z',
      }}
    />
  </IndexTableRow>
);

export default JourneyRow;
